import { render, staticRenderFns } from "./v-right-card3.vue?vue&type=template&id=d37c36dc&scoped=true"
import script from "./v-right-card3.vue?vue&type=script&lang=js"
export * from "./v-right-card3.vue?vue&type=script&lang=js"
import style0 from "./v-right-card3.vue?vue&type=style&index=0&id=d37c36dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37c36dc",
  null
  
)

export default component.exports